import { createEvent, restore, sample } from 'effector'
import {
  RevisionsRequest,
  RevisionsResponse,
  RevisionItemFromServer,
} from './types'
import { fx } from '../../../../libs'

export const revisionsMounted = createEvent<RevisionsRequest>()

export const getRevisions = fx<void, RevisionsResponse>({
  method: 'GET',
  url: '/finance/revision',
})

export const $revisions = restore<RevisionItemFromServer[]>(
  getRevisions.doneData.map((a) => a.body.items),
  [],
)

export const $totalRevisions = restore(
  getRevisions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: revisionsMounted,
  fn: ({ limit, page, orderBy, orderDirection }) => {
    // let filtersTransactionsParams = {}

    let query = {
      limit,
      page,
    }

    if (orderBy && orderDirection) {
      if (orderBy === 'name') {
        orderBy = 'wallet'
      }
      // @ts-ignore
      query['order'] = `${orderDirection === 'asc' ? '' : '-'}${orderBy}`
    }

    // if (Object.keys(filtersTransactionsParams).length) {
    //   // @ts-ignore
    //   query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    // }

    return {
      url: `/finance/revision`,
      query,
    }
  },
  target: getRevisions,
})
